import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class Header extends React.PureComponent {
    static propTypes = {};

    state = {};

    // 全站渠道标记传递，文章页的任意跳转

    render() {
        return (
            <div className={styles.header}>
                <a href="http://www.ifeng.com/" target="_blank" className={styles.logo}>
                    <img src="//p1.ifengimg.com/allsite/login/login_logo.png" />
                </a>
            </div>
        );
    }
}

export default errorBoundary(Header);
